import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { brandColors } from 'styles/colors';

export const AccordionContainer = styled.div`
	width: 100%;
	margin: 0 auto;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	overflow: hidden;
`;

export const AccordionItem = styled.div``;

export const AccordionHeader = styled.div`
	padding: 8px 15px;
	background-color: ${({ isActive }) =>
		isActive ? '#92C775' : `${colors.grey2}`};
	cursor: pointer;
	font-weight: bold;
	display: flex;
	justify-content: space-between;
	align-items: center;
  color: ${colors.grey6}
	transition: transform 0.3s ease-in-out;
	&:hover {
		transition: transform 0.3s ease-in-out;
		background-color: #ddd;
	}
`;

export const NoDataMessage = styled.div`
	color: grey;
	font-size: 1.5rem;
`;

export const Arrow = styled.span`
	font-size: 18px;
	transition: transform 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
	transform: ${({ isActive }) =>
		isActive ? 'rotate(0deg)' : 'rotate(180deg)'};
	.material-icons-outlined {
		font-size: 28px;
		vertical-align: middle;
	}
`;

export const AccordionContent = styled.div`
	overflow: hidden;
	max-height: ${({ isActive }) => (isActive ? '1000px' : '0')};
	transition: max-height 0.6s cubic-bezier(0.645, 0.045, 0.355, 1),
		padding 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
	padding: ${({ isActive }) => (isActive ? '0 15px' : '0 15px')};
	background-color: ${colors.white};
	color: ${colors.grey6};
`;

export const ChildList = styled.div`
	padding: 1%;
`;

export const ChildItem = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
`;

export const TutorialLink = styled.div`
	cursor: pointer;
	color: ${colors.grey6};
	transition: transform 0.3s ease-in-out;
	&:hover {
		color: ${brandColors.green};
	}
`;
